import React, { memo, useCallback } from 'react'
import { TAB_CONFIG, SEARCH_TABS } from '../types'
import type { SearchTab, ResultCounts } from '../types'
import { TabBarContainer, TabButton, TabCount } from '../styles'

type SearchTabBarProps = {
  activeTab: SearchTab
  onTabChange: (tab: SearchTab) => void
  counts: ResultCounts
}

const getCountForTab = (tabId: SearchTab, counts: ResultCounts): number | null => {
  if (tabId === SEARCH_TABS.ALL) return null
  return counts[tabId as keyof ResultCounts] || 0
}

export const SearchTabBar = memo<SearchTabBarProps>(
  ({ activeTab, onTabChange, counts }) => {
    const handleTabClick = useCallback(
      (tabId: SearchTab) => () => onTabChange(tabId),
      [onTabChange]
    )

    return (
      <TabBarContainer role="tablist" aria-label="Search result categories">
        {TAB_CONFIG.map((tab) => {
          const count = getCountForTab(tab.id, counts)
          const isActive = activeTab === tab.id

          return (
            <TabButton
              key={tab.id}
              role="tab"
              aria-selected={isActive}
              aria-controls={`tabpanel-${tab.id}`}
              onClick={handleTabClick(tab.id)}
              $isActive={isActive}
              type="button"
            >
              {tab.label}
              {count !== null && count > 0 && (
                <TabCount $isActive={isActive}>{count}</TabCount>
              )}
            </TabButton>
          )
        })}
      </TabBarContainer>
    )
  }
)

SearchTabBar.displayName = 'SearchTabBar'
